"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindStyleToSelector = void 0;
const create_classname_1 = require("./create-classname");
const add_class_rule_1 = require("./add-class-rule");
const bind_class_to_selector_1 = require("./bind-class-to-selector");
function bindStyleToSelector(declaration, selector) {
    const classname = create_classname_1.createClassname();
    add_class_rule_1.addClassRule(classname, declaration);
    return bind_class_to_selector_1.bindClassToSelector(classname, selector);
}
exports.bindStyleToSelector = bindStyleToSelector;
//# sourceMappingURL=bind-style-to-selector.js.map